import React from 'react';
import { fileUrl } from './gameUtils';

export function PlayerAvatarIcon({ className = 'w-7 h-7' }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className={className}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
    </svg>
  );
}

// Used by the lineup, player and sub pickers.
export function PlayerTile({ player, selected, onClick, dimmed = false, testId }) {
  return (
    <button type="button" onClick={onClick}
      data-testid={testId}
      className={`relative flex flex-col items-center justify-center rounded-2xl px-3 py-3 sm:py-4 transition-all
        bg-[#0F1A4A] active:scale-[0.97]
        ${selected ? 'border-2 border-emerald-400 shadow-[0_0_22px_rgba(52,211,153,0.25)]' : 'border-2 border-white/15 hover:border-white/40'}
        ${dimmed ? 'opacity-40' : ''}`}>
      <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-white/5 border border-white/30 flex items-center justify-center text-white/70 mb-1 overflow-hidden">
        {player.headshot_path ? (
          <img src={fileUrl(player.headshot_path)} alt=""
            className="w-full h-full object-cover" onError={(e) => { e.target.style.display = 'none'; }} />
        ) : (
          <PlayerAvatarIcon />
        )}
      </div>
      <div className="text-center leading-tight">
        <div className="text-amber-300 font-black text-sm sm:text-base italic">#{player.jersey_number || '?'}</div>
        <div className="text-white text-[11px] sm:text-xs font-semibold leading-snug">
          {(player.name || '').split(/\s+/).slice(0, 2).map((w, i) => (
            <div key={i}>{w}</div>
          ))}
        </div>
      </div>
    </button>
  );
}
